// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import App from './App'
import router from './router/lazy'
import Viser from 'viser-vue'
// import CKEditor from 'ckeditor4-vue'
import axios from 'axios'
// // import '@/mock'
import store from './store'
// // import PouchDB from 'pouchdb'
import request from '../src/utils/request'
import globalVariable from './utils/globalVariable' // 公共解析公式
import getKeys from './utils/getKeys' // 获取唯一id
import '@/assets/common.less'
// import { userPermission } from '@/api/user'
import { getRandomId } from '@/utils/util'
//import MenuView from '@/layouts/MenuView'
import constants from './utils/constants'

window.constants = constants;
Vue.prototype.$getKey = getKeys
Vue.prototype.$axios = axios
Vue.prototype.$request = request
Vue.prototype.getRandomId = getRandomId
Vue.prototype.$userInfo = (localStorage.getItem('userInfo1') && JSON.parse(localStorage.getItem('userInfo1'))) || {}
//Vue.prototype.$routedata = (localStorage.getItem('routedata') && JSON.parse(localStorage.getItem('routedata'))) || {}
Vue.prototype.$routedata = (sessionStorage.getItem('routedata') && JSON.parse(localStorage.getItem('routedata'))) || {}
Vue.prototype.commonsVariable = globalVariable
Vue.config.productionTip = false
Vue.use(Viser)
Vue.use(Antd)
let _import = function (file) {
  return () => import(`./../src${file}`)
}
let formatRouter = function (data) {
  const accessedRouters = data.filter(route => {
    if (route.component) {
      if (route.component === 'login') {     // login组件特殊处理
        route.component = _import('@/pages/login/Login')
      } else {
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = formatRouter(route.children)
    }
    return true
  })
  return accessedRouters
}

// Vue.use(CKEditor)
/* eslint-disable no-new */
// 取到用户的角色
const userInfo = (localStorage.getItem('userInfo1') && JSON.parse(localStorage.getItem('userInfo1'))) || {}
let getRouter = '';
let appVue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    let flag = window.location.href.includes('#/video')
    let routedata = []
    if (localStorage.getItem('userInfo1')) {
      //if((JSON.parse(localStorage.getItem('menudata')) && JSON.parse(localStorage.getItem('menudata1'))) || JSON.parse(localStorage.getItem('menudata'))){
      // if ((JSON.parse(localStorage.getItem('menudata')) && JSON.parse(localStorage.getItem('menudata1'))) || JSON.parse(localStorage.getItem('menudata'))) {
      //   //routedata = JSON.parse(localStorage.getItem('menudata'))
      //   routedata = JSON.parse(localStorage.getItem('menudata'))
      // } else {
      //   //routedata = JSON.parse(localStorage.getItem('menudata1'))
      //   routedata = JSON.parse(localStorage.getItem('menudata1'))
      // }
      let routedata1 = JSON.parse(localStorage.getItem('menudata') || '[]');
      let routedata2 = JSON.parse(localStorage.getItem('menudata1') || '[]');
      //let routedata2 = JSON.parse(localStorage.getItem('menudata1') || '[]');
      if (routedata1.length && routedata2.length) {
        routedata1[0].children = (routedata1[0].children || []).concat(routedata2[0].children || [])
        routedata = routedata1;
      } else if (routedata1.length) {
        routedata = routedata1;
      } else if (routedata2.length) {
        routedata = routedata2;
      }
      try {
        if (routedata && routedata.length > 0) {
          formatRouter(routedata)
          getRouter = routedata
          router.addRoutes(routedata)
        } else {
          this.$router.push('/')
        }
      } catch (error) { 
        this.$router.push('/')
      }
    } else if (flag) {
    } else {
      this.$router.push('/')
    }
  }
})
router.beforeEach((to, from, next) => {
  if (getRouter && !sessionStorage.getItem('relist')) {
    if(to.name==="首页"){
      next({ name: '登录页'})
    }else{
      next(...to)
    }
  } else {
    sessionStorage.removeItem('relist')
    let routedata = []
    if (localStorage.getItem('userInfo1')) {
      //let routedata1 = JSON.parse(localStorage.getItem('menudata') || '[]');
      let routedata1 = JSON.parse(localStorage.getItem('menudata') || '[]');
      let routedata2 = JSON.parse(localStorage.getItem('menudata1') || '[]');
      //let routedata2 = JSON.parse(localStorage.getItem('menudata1') || '[]');
      if (routedata1.length && routedata2.length) {
        routedata1[0].children = (routedata1[0].children || []).concat(routedata2[0].children || [])
        routedata = routedata1;
      } else if (routedata1.length) {
        routedata = routedata1;
      } else if (routedata2.length) {
        routedata = routedata2;
      }
      try {
        if (routedata && routedata.length > 0) {
          formatRouter(routedata)
          getRouter = routedata
          router.addRoutes(routedata)
          next({ ...to, replace: true })
        } else {
          next()
        }
      } catch (error) { 
        console.log(error)
        this.$router.push('/') 
      }
    } else {
      next()
    }
  }
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.reload()
    // router.replace(router.history.pending.fullPath)
  } else {
    console.log(error)
  }
})





// WEBPACK FOOTER //
// ./src/main.js